<template>
  <div v-if="isShow" class="category plr-110 flex flex-sb">
    <div @click="toCategory(item)" v-for="(item, index) in categoryList" :key="index"
      :class="(category == item.category ? 'c-primary borer-bottom f-bold' : '')" class="f-16 c-33 pointer">{{item.title}}
    </div>
  </div>
</template>

<script>
  import {
    getCategoryList
  } from '@/utils/category'
  import {
    mapGetters
  } from 'vuex'
  export default {
    data() {
      return {
        categoryList: [{
          title: '首页',
          category: 'A0',
          url: 'index'
        }]
      }
    },
    computed: {
      ...mapGetters([
        'category'
      ]),
      isShow() {
        return this.$route.path.indexOf('/modules') != -1
      }
    },
    created() {
      this.categoryList = this.categoryList.concat(getCategoryList() || [])
    },
    methods: {
      toCategory(item) {
        this.$store.commit('user/SET_CATEGORY', item.url == 'index' ? '' : item.category)
        this.$router.push((item.url == 'index' ? '/' : '/modules/') + item.url)
      }
    }
  }

</script>

<style lang="scss" scoped>
  .category {
    height: 44px;
    line-height: 44px;
  }

  .borer-bottom {
    border-bottom: 3px solid #C00202;
  }

</style>
